<template>
  <UIBox column class="asb-highlights">
    <UIBox class="asb-highlights__header">
      <UIBox class="asb-highlights__header-icon"/>
      <UIText class="asb-highlights__header-label">
        {{translations.Headers.Highlights}}
      </UIText>
    </UIBox>
    <UILoader :grow="grow" :loading="topSportsAndEvents.isTopEventsLoading" column>
      <UITabs
        class="asb-highlights__tabs"
        @change="onTabsChange"
        :items="sports"
        :selectedItem="topSportsAndEvents.selectedSport"
      >
        <template v-slot:header-item-content="{item}">
          <UIText>{{item.Name}}</UIText>
        </template>
        <UIBox slot="last-header-item-content"></UIBox>
        <template v-slot="{item}">
          <UIBox v-if="events.length" grow column class="asb-highlights__tabs-content">
            <template v-for="event in events">
              <CEventRow :event="event" :key="event.Id"></CEventRow>
            </template>
          </UIBox>
          <CNodata v-else/>
        </template>
      </UITabs>
    </UILoader>
  </UIBox>
</template>

<script>
import CEventRow from '@/components/CEventRow/CEventRow.vue'
import CNodata from '@/components/CNodata/CNodata.vue'
import translations from '@/requests/staticTranslationsQuery'
import { GetTopSportsAndEvents } from '@/requests/topSportsAndEvents'
import { EventEnums } from '@altenar/models'

export default {
  name: 'WHighlights',
  props: {
    maxTabs: {
      type: Number,
      default: 3
    }
  },
  data: () => {
    return {
      translations,
      topSportsAndEvents: new GetTopSportsAndEvents(EventEnums.TopEventsType.HIGHLIGHTS),
      sports: [],
      events: []
    }
  },
  beforeDestroy() {
    this.topSportsAndEvents.stop()
  },
  created() {
    this.topSportsAndEvents.fetchSports()
    this.topSportsAndEvents.onTopEventsReceive = events => this.events = events
    this.topSportsAndEvents.onTopSportsReceive = sports => {
      const otherSportsIndex = sports.findIndex(sport => sport.SportId === -1)
      if (otherSportsIndex > -1) {
        sports[otherSportsIndex].Name = this.translations.Common.Others
      }
      this.sports = sports
      this.sports.splice(this.maxTabs)
    }
  },
  methods: {
    onTabsChange(sport) {
      this.topSportsAndEvents.selectedSport = sport
      this.topSportsAndEvents.fetchEventsBySport({
        count: 10,
        showAllEvents: false,
        sportId: sport.SportId
      })
    }
  },
  components: { CNodata, CEventRow }
}
</script>
